module.exports = __webpack_public_path__ + "img/thumb_12.ea605b3e.jpg";